// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkOperationPage {
  height: 100%;
  width: 100%;
  padding: 10px;
}

  .BulkOperationPage__upload-container {
    height: 100px;
    width: 100%;
    margin-bottom: 20px;
    padding-left: 10px;
  }

  .BulkOperationPage__upload-container-error {
      height: 20px;
      color: red;
    }

  .BulkOperationPage__upload-container-file-select {
      width: 250px;
      margin-bottom: 5px
    }

  .BulkOperationPage__table-container {
    width: 100%;
    height: 800px;
    display: flex;
    flex-direction: column;
    padding-left: 10px;
  }

  .BulkOperationPage__table-header {
    display: flex;
  }

  .BulkOperationPage__table-header-cell {
      width: 25%;
      max-width: 25%;
      border: 1px solid black;
      padding: 5px;
    }

  .BulkOperationPage__table-content {
    height: 100%;
    border: 1px solid black;
    overflow-y: scroll;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/BulkOperationPage/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AA2Cf;;EAzCE;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EAWpB;;EATE;MACE,YAAY;MACZ,UAAU;IACZ;;EAEA;MACE,YAAY;MACZ;IACF;;EAGF;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EAQf;;EANE;MACE,UAAU;MACV,cAAc;MACd,uBAAuB;MACvB,YAAY;IACd;;EAGF;IACE,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;EACpB","sourcesContent":[".BulkOperationPage {\n  height: 100%;\n  width: 100%;\n  padding: 10px;\n\n  &__upload-container {\n    height: 100px;\n    width: 100%;\n    margin-bottom: 20px;\n    padding-left: 10px;\n\n    &-error {\n      height: 20px;\n      color: red;\n    }\n\n    &-file-select {\n      width: 250px;\n      margin-bottom: 5px\n    }\n  }\n\n  &__table-container {\n    width: 100%;\n    height: 800px;\n    display: flex;\n    flex-direction: column;\n    padding-left: 10px;\n  }\n\n  &__table-header {\n    display: flex;\n\n    &-cell {\n      width: 25%;\n      max-width: 25%;\n      border: 1px solid black;\n      padding: 5px;\n    }\n  }\n\n  &__table-content {\n    height: 100%;\n    border: 1px solid black;\n    overflow-y: scroll;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
